import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { cn } from '@/lib/utils';

export default function PasswordField({
  id,
  label,
  register,
  error,
  placeholder,
  autoComplete,
  className,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={cn('input-group', className)}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <div className="relative">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          className="pr-12"
          placeholder={placeholder}
          autoComplete={autoComplete}
          {...register}
        />
        <button
          type="button"
          tabIndex={-1}
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 text-[var(--festy-muted-text)] hover:text-[#121212]"
          onClick={() => setVisible((s) => !s)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          <FontAwesomeIcon icon={['fas', visible ? 'eye-slash' : 'eye']} />
        </button>
      </div>
      {error ? (
        <div className="mt-1 text-sm font-bold text-[var(--destructive)]">
          {error}
        </div>
      ) : null}
    </div>
  );
}
